<template>
  <div class="dismantle el-progress">
    <v-chart :options="gaugeOption"></v-chart>
    <div class="text" v-if="from !== 'otherPage'">设备在线率</div>
  </div>
</template>

<script>
import Echarts from 'vue-echarts/components/ECharts'
import $echarts from 'echarts'
import 'echarts/theme/macarons'

export default {
  components: {
    'v-chart': Echarts,
  },
  props: {
    from: {
      type: String,
      default: 'safety',
    },
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '300px',
    },
    value: {
      type: Number,
      default: 0,
    },
    radius: {
      type: String,
      default: '70%',
    },
  },
  created() {
    if (this.radius) {
      this.gaugeOption.series[0].radius = this.radius
    }
  },
  data() {
    return {
      gaugeOption: {
        series: [
          {
            name: '',
            type: 'gauge',
            radius: '70%',
            z: 4,
            startAngle: 220,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [],
                width: 5,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            pointer: {
              show: false,
            },
            title: {
              show: false,
              offsetCenter: ['0%', '20%'],
              fontSize: 12,
              color: '#fff',
              height: 26,
            },
            detail: {
              show: true,
              color: '#fff',
              fontSize: 16,
              fontWeight: 'bold',
              offsetCenter: ['0%', '0%'],
              formatter(value) {
                return `${value}%`
              },
            },
            data: [
              {
                value: 0,
              },
            ],
          },
          {
            name: '',
            type: 'gauge',
            radius: '68%',
            z: 3,
            startAngle: 220,
            endAngle: -45,
            axisLine: {
              lineStyle: {
                color: [[1, 'rgba(217, 217, 217, 0.1)']],
                width: 2.5,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
        ],
      },
    }
  },
  mounted() {},
  methods: {
    setOptions(value) {
      const colors = new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: '#97baff',
        },
        {
          offset: 1,
          color: '#4945e8',
        },
      ])
      const percentage = value / 100
      this.gaugeOption.series[0].axisLine.lineStyle.color = [
        [percentage, colors],
      ]
      this.gaugeOption.series[0].data[0].value = value
    },
  },
  watch: {
    value: {
      handler(val) {
        console
        this.setOptions(val)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
canvas,
.echarts {
  width: 100% !important;
  height: 100% !important;
}

.bottom_text {
  width: 100%;
  text-align: center;
  position: absolute;
}
.dismantle {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .text {
    position: absolute;
    top: 76px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
  }
}
::v-deep .el-progress__text {
  font-size: 17px !important;
  font-weight: bold !important;
  color: #fff !important;
}
</style>
